import { inject, Injectable } from "@angular/core";
import { Router } from "@angular/router";
import { retryOnNavigation } from "@app/core/helpers";
import { PosMarketplaceService } from "clearline-api";
import { UserPermissionService } from "clearline-common";
import { defer, Observable } from "rxjs";
import { switchMap, tap } from "rxjs/operators";
import { AccountMessageEvent, AccountMessagesService } from "./account-messages.service";

@Injectable({ providedIn: "root" })
export class PosConnectionStatusRefreshService {
  private readonly accountMessagesService = inject(AccountMessagesService);
  private readonly posMarketplaceService = inject(PosMarketplaceService);
  private readonly router = inject(Router);
  private readonly userPermissionService = inject(UserPermissionService);

  watch(): Observable<void> {
    return this.accountMessagesService.on(AccountMessageEvent.PosMarketConnectionStatusChanged).pipe(
      tap(() => this.posMarketplaceService.notifyConnectionStatusChanged()),
      switchMap(() => this.reloadPermissions())
    );
  }

  private reloadPermissions(): Observable<void> {
    return defer(() => {
      const wasRouteAllowed = this.userPermissionService.hasRoutePermission(this.router.url);

      return this.userPermissionService.reload().pipe(tap(() => this.leaveLostRoute(wasRouteAllowed)));
    }).pipe(retryOnNavigation(this.router));
  }

  private leaveLostRoute(wasRouteAllowed: boolean): void {
    if (wasRouteAllowed && !this.userPermissionService.hasRoutePermission(this.router.url)) {
      this.router.navigateByUrl("/");
    }
  }
}
